export type CustomStorageProvider = 'aliyun_oss' | 'tencent_cos'

export type CustomStorageConfig = {
  provider: CustomStorageProvider
  bucket: string
  region: string
  endpoint: string
  access_key_id: string
  access_key_secret: string
  public_base_url: string
  prefix: string
}

export function emptyCustomStorageConfig(provider: CustomStorageProvider = 'aliyun_oss'): CustomStorageConfig {
  if (provider === 'tencent_cos') {
    return {
      provider,
      bucket: '',
      region: 'ap-guangzhou',
      endpoint: '',
      access_key_id: '',
      access_key_secret: '',
      public_base_url: '',
      prefix: '',
    }
  }
  return {
    provider: 'aliyun_oss',
    bucket: '',
    region: 'oss-cn-hangzhou',
    endpoint: 'https://oss-cn-hangzhou.aliyuncs.com',
    access_key_id: '',
    access_key_secret: '',
    public_base_url: '',
    prefix: '',
  }
}

export function customStorageConfigFromRecord(
  raw?: Record<string, string | undefined> | null,
): CustomStorageConfig {
  const provider =
    raw?.provider === 'tencent_cos' || raw?.provider === 'tencent'
      ? 'tencent_cos'
      : 'aliyun_oss'
  const base = emptyCustomStorageConfig(provider)
  return {
    ...base,
    provider,
    bucket: String(raw?.bucket ?? ''),
    region: String(raw?.region ?? base.region),
    endpoint: String(raw?.endpoint ?? base.endpoint),
    access_key_id: String(raw?.access_key_id ?? ''),
    access_key_secret: '',
    public_base_url: String(raw?.public_base_url ?? ''),
    prefix: String(raw?.prefix ?? ''),
  }
}

export function customStorageConfigToPayload(
  cfg: CustomStorageConfig,
  opts?: { omitEmptySecret?: boolean },
): Record<string, string> {
  const out: Record<string, string> = {
    provider: cfg.provider,
    bucket: cfg.bucket.trim(),
    region: cfg.region.trim(),
    endpoint: cfg.endpoint.trim(),
    access_key_id: cfg.access_key_id.trim(),
  }
  const secret = cfg.access_key_secret.trim()
  if (secret || !opts?.omitEmptySecret) {
    out.access_key_secret = secret
  }
  const pub = cfg.public_base_url.trim()
  if (pub) out.public_base_url = pub
  const prefix = cfg.prefix.trim()
  if (prefix) out.prefix = prefix
  return out
}

/** 返回 i18n key，无错误返回 null */
export function validateCustomStorageConfig(
  cfg: CustomStorageConfig,
  opts?: { secretOptional?: boolean },
): string | null {
  if (!cfg.bucket.trim()) return 'storageConfig.bucketRequired'
  if (!cfg.region.trim()) return 'storageConfig.regionRequired'
  if (!cfg.endpoint.trim()) return 'storageConfig.endpointRequired'
  if (!cfg.access_key_id.trim()) return 'storageConfig.accessKeyIdRequired'
  if (!opts?.secretOptional && !cfg.access_key_secret.trim()) return 'storageConfig.accessKeySecretRequired'
  return null
}
